<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="category.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                placeholder="Name"
            />

            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            category: {}
        };
    },

    watch: {
        category() {
            this.$emit('input', this.category);
        }
    },

    created() {
        this.category = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.category[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.category,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
